import React from 'react';
import { BaseButton, useT } from '@repo/common';

function DegreeList({ onSelect }) {
  const t = useT();
  const options = [
    'In progress',
    'Associate',
    'Bachelor’s',
    'Master’s',
    'Ph.D',
    'Other',
  ];

  return (
    <div
      className='w-full min-w-[334px] h-[206px] tabletH:h-auto overflow-y-auto bg-grayscale-gray00 border border-grayscale-gray02 
                rounded-[15px] p-2 shadow-popup-02'
      onClick={(e) => {
        e.preventDefault();
        e.stopPropagation();
      }}
    >
      <ul role='menu' className='list-none p-0 m-0'>
        {options.map((option) => (
          <li
            key={option}
            className='flex items-center rounded-lg transition-colors duration-150'
          >
            <BaseButton
              type='text'
              size='m'
              hideIcon
              bgclass='bg-grayscale-gray00'
              borderclass='border-none'
              textclass='justify-start'
              hoverclass='hover:bg-grayscale-gray01 hover:text-text-primary'
              activeclass='active:bg-grayscale-gray02 active:text-text-primary'
              width='100%'
              onMouseDown={(e) => {
                e.preventDefault();
                e.stopPropagation();
                onSelect(option);
              }}
              leftalign='true'
            >
              {t(
                option,
                {
                  'In progress': '진행 중',
                  Associate: '전문학사',
                  'Bachelor’s': '학사',
                  'Master’s': '석사',
                  'Ph.D': '박사',
                  Other: '기타',
                }[option],
              )}
            </BaseButton>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DegreeList;
